import {MobileHeaderStates} from 'app/components/mobileHeader/interface';
import {Nullable} from 'app/interface';

export const MOBILE_HEADER_SLICE_KEY = 'mobileHeader';

export type MobileHeaderStoreState = {
    mobileMenu: boolean;
    mobileHeaderState: Nullable<MobileHeaderStates>;
    bypassScrollEvent: boolean;
    isSearchFocus: boolean;
};

export const getDefaultMobileHeaderStoreState = (): MobileHeaderStoreState => {
    return {
        mobileMenu: false,
        mobileHeaderState: null,
        bypassScrollEvent: false,
        isSearchFocus: false,
    };
};

declare module 'app/gemStore' {
    interface DynamicSlices {
        mobileHeader: MobileHeaderStoreState;
    }
}
